/*
 * 删除
 * 停用、启用
 * 工单回收规则
 * */
import { ticketClient } from "@/api/ticketClient";
import { CommonIn } from "@/pbjs/xcommon/common_pb";
import { DeleteTicketAssignRuleReq } from "@/pbjs/xcommon/ticket_pb";
import { localGet, setMetaData } from "@/utils";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
// import router from '@/router'
//  lee  接口参数
interface IDeleteTicketRecycleRuleReqOptions {
  id: number;
  action: number;
}
// 规则行为
enum RuleAction {
  RuleAction_UNSPECIFIED = 0,
  RuleAction_Start = 1, // 启用
  RuleAction_Stop = 2, // 停用
  RuleAction_Delate = 3 // 删除
}
export function deleteTicketAssignRule(
  arg: IDeleteTicketRecycleRuleReqOptions
) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DeleteTicketAssignRuleReq();
      request.setCommonin(setCommon());
      request.setId(arg.id);
      request.setAction(arg.action);
      // setRank
      await ticketClient.deleteTicketAssignRule(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
